import { render } from "./ClientList.vue?vue&type=template&id=fb71caee&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"

import "./ClientList.vue?vue&type=style&index=0&id=fb71caee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb71caee"]])

export default __exports__